import { all, put, select, takeLatest } from 'redux-saga/effects';
import { ClientOrderActionTypes } from './orders-actions';
import { clientOrdersStore } from './orders-store';
import getOrderListApi from '@api/clients/orders/get-orders';
import getOrderPdf from '@api/financials/order-pdf';
import getPreInvoice from '@api/clients/orders/get-pre-invoice';
import { AlertActionType } from '@store/alert/alert-action';
import singleSettingApi from '@api/settings/single-setting';

function* getClientPreInvoiceWatcher() {
  try {
    const preInvoiceResponse: { data: { data: object } } = yield getPreInvoice({ cache: 'no-cache' });

    yield put({
      type: ClientOrderActionTypes.SET_CLIENT_PRE_INVOICE,
      data: {
        preInvoiceList: preInvoiceResponse?.data?.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}

function* getClientOrdersWatcher() {
  const { currentPage, ordersList, orderType } = yield select(clientOrdersStore);

  try {
    const ordersListResponse: { data: { data: Array<object>, last_page?: string } } = yield getOrderListApi({ moduleId: undefined, page: currentPage, limit: 15, cache: 'no-cache', type: orderType });
    yield put({
      type: ClientOrderActionTypes.SET_CLIENT_ORDERS,
      data: {
        ordersList: [...ordersList, ...ordersListResponse?.data?.data],
        lastPage: ordersListResponse?.data?.last_page,
      },
    });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}

function* pdfOrderResultWatcher() {
  try {
    const { pdfResultId } = yield select(clientOrdersStore);

    yield getOrderPdf({
      id: pdfResultId,
      cache: 'no-cache',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'file.pdf');
      document.body.appendChild(link);
      link.click();
    });

    yield put({
      type: ClientOrderActionTypes.SET_PDF_RESULT_LOADING,
    });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
    yield put({
      type: ClientOrderActionTypes.SET_PDF_RESULT_LOADING,
    });
  }
}

function* getComplaintsRespondTimeWatcher() {
  try {
    const complaintRespondTimeSetting: { data: { value: string } } = yield singleSettingApi({ cache: 'no-cache', key: 'maximum_time_for_submit_complaint' });

    yield put({
      type: ClientOrderActionTypes.SET_COMPLAINT_RESPOND_TIME,
      data: {
        complaintRespondTime: complaintRespondTimeSetting?.data?.value,
      },
    });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}

function* setOrderTypeWatcher() {
  const { orderType } = yield select(clientOrdersStore);

  if (orderType === 'PRE_INVOICE') {
    yield getClientPreInvoiceWatcher();
  } else {
    yield getClientOrdersWatcher();
  }
}

function* clientOrdersMiddleware() {
  yield all([
    takeLatest(ClientOrderActionTypes.GET_CLIENT_ORDERS, getClientOrdersWatcher),
    takeLatest(ClientOrderActionTypes.GET_PDF_RESULT, pdfOrderResultWatcher),
    takeLatest(ClientOrderActionTypes.GET_EXTENDED_ORDER_LIST, getClientOrdersWatcher),
    takeLatest(ClientOrderActionTypes.GET_CLIENT_PRE_INVOICE, getClientPreInvoiceWatcher),
    takeLatest(ClientOrderActionTypes.GET_COMPLAINT_RESPOND_TIME, getComplaintsRespondTimeWatcher),
    takeLatest(ClientOrderActionTypes.SET_ORDER_TYPE, setOrderTypeWatcher),
  ]);
}

export default clientOrdersMiddleware;
